import { Component, OnInit } from '@angular/core';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';

@Component({
  selector: 'app-miles-balance-animation',
  templateUrl: './miles-balance-animation.component.html',
  styleUrls: ['./miles-balance-animation.component.scss']
})
export class MilesBalanceAnimationComponent implements OnInit {

	isAlive = true;

	isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	isCorporate: boolean;

	constructor(protected sidebarService: SidebarService, private store: Store<fromStore.State>) {

		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					if (value === true) {
						this.isCorporate = true;
					} else {
						this.isCorporate = false;
					}
				}
			);
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.isAlive = false;
	}
}
